import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../ContextApi";
import { CircularProgress } from "@mui/material";

const PageNotFound = () => {
  const [countdown, setCountdown] = useState(5);
  const [showPage, setShowPage] = useState(false);
  const navigate = useNavigate();
  const { getDecryptedSessionItem } = useContext(MyContext);

  useEffect(() => {
    setTimeout(() => {
      setShowPage(true);
    }, 1000);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      if (
        getDecryptedSessionItem("clientId") === "" ||
        getDecryptedSessionItem("clientId") === null
      ) {
        // console.log("Navigate To Login");
        navigate("/");
      } else {
        // console.log("Navigate To Scan Qr");
        navigate("/scan-qr");
      }
    }, countdown * 1000);
    return () => {
      clearInterval(timer);
      clearTimeout(timeout);
    };
  }, [countdown, navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "16px",
        height: "70vh",
        alignItems: "center",
      }}
    >
      {showPage && (
        <div
          style={{
            margin: "auto",
            textAlign: "center",
          }}
        >
          <img
            style={{
              height: "300px",
              marginBottom: "2px",
            }}
            src="errorImage.png"
            alt="error"
          />
          <h1
            style={{
              fontSize: "70px",
              fontWeight: "800",
              color: "red",
            }}
          >
            404
          </h1>
          <div style={{ fontSize: "30px", color: "gray", marginTop: "4px" }}>
            Page not found
          </div>
          <p style={{ fontSize: "30px", color: "gray", marginTop: "4px" }}>
            Sorry, the requested page does not exit!
          </p>
          <CircularProgress />
          <p style={{ fontSize: "15px", color: "gray", marginTop: "4px" }}>
            Redirecting in {countdown} seconds...
          </p>
        </div>
      )}
    </div>
  );
};

export default PageNotFound;
